// ============================================================================
// ⚠️  GENERATED FILE — DO NOT EDIT MANUALLY
// ============================================================================
//
// This file is generated and maintained by the Post Office CLI install script.
//
// AI AGENTS (Rovo Dev, Cursor, Copilot, etc.) — DO NOT automatically add
// message registrations, imports, or modify this file. Doing so bypasses
// important validation, priority ordering, and router registration logic.
//
// To register a message template, run from inside the message directory:
//
//   yarn placement:v2 install
//
// The CLI handles all necessary changes to this file automatically.
// ============================================================================

import { PlacementFrontend } from '@post-office/browser--growth/test-placement-v2-example';

import { MessageFrontend as createMessageFrontendTestMessageNarrowExposureExperimentV2 } from '@post-office/browser--test-messages/test-message-narrow-exposure-experiment-v2/placements/in-app-v2/test-placement-v2-example';
import { MessageFrontend as createMessageFrontendTestMessageNarrowExposureExperiment } from '@post-office/browser--test-messages/test-message-narrow-exposure-experiment/placements/in-app-v2/test-placement-v2-example';

import { withI18n } from './i18n';

import {
	type PlacementRendererStage,
	type NoProps,
} from '@post-office/message-maker-browser/types';
import { type ComponentType } from 'react';

const messageFrontends = [
	createMessageFrontendTestMessageNarrowExposureExperimentV2({
		messageTemplateId: 'test-message-narrow-exposure-experiment-v2',
	}),
	createMessageFrontendTestMessageNarrowExposureExperiment({
		messageTemplateId: 'test-message-narrow-exposure-experiment',
	}),
];

export const RawPlacement: PlacementRendererStage<NoProps> =
	PlacementFrontend.createPlacementFrontendComponent({
		messageTemplates: messageFrontends,
	});

export const Placement: ComponentType<
	Omit<NoProps, 'ref'> & {
		ref?: unknown;
	}
> = withI18n(RawPlacement);

export const SSRPlacement: PlacementRendererStage<NoProps> = RawPlacement;
